import {WATERMARK_JSDK} from '@/Constant';
import kuPiper from '@/middleware/kuPiper';
import appendChildError from './appendChildError';
interface IWaterMarkConfig{
    curRepositoryGuid: string;
    hasDocsWaterMark: boolean;
}
let WaterMarkConfig: IWaterMarkConfig = {
    curRepositoryGuid: '',
    hasDocsWaterMark: false,
};

export const loadWaterMarkSdk = kuPiper.runProxy(
    kuPiper.proxyNameMap.loadWaterMarkSdkProxy,
    (res: any, repositoryGuid: string, source?: string) => {
        // sdk是不是加载过了
        const headDom = Array.from(document.head.children);
        const hasWatermarkSdk = headDom.some(ite => ite.id === 'watermarkSdkId');

        const openWaterMarks = (res: any) => {
            (window as any)?.loadDivWatermarkUC &&
            (window as any).loadDivWatermarkUC(
                res.id,
                res.sign,
                'waterMarkContainer'
                , '', '', undefined,
                () => {
                    // 水印失败回调
                    WaterMarkConfig = Object.assign(WaterMarkConfig, {
                        curRepositoryGuid: repositoryGuid,
                        hasDocsWaterMark: false,
                    });
                }
            );
            WaterMarkConfig = Object.assign(WaterMarkConfig, {
                curRepositoryGuid: repositoryGuid,
                hasDocsWaterMark: true,
            });
        };
        // 文档已经存在水印
        const exist = (repositoryGuid === WaterMarkConfig.curRepositoryGuid) && WaterMarkConfig.hasDocsWaterMark;
        if (source && source === 'docs' && exist) {
            return;
        }
        // 已经有jsdk 直接开水印
        if (hasWatermarkSdk) {
            openWaterMarks(res);
            return;
        }

        // 没有jsdk 加载jsdk并开启水印
        const scriptDom = document.createElement('script');
        scriptDom.setAttribute('type', 'text/javascript');
        scriptDom.setAttribute('id', 'watermarkSdkId');
        scriptDom.setAttribute('src', WATERMARK_JSDK);
        scriptDom.setAttribute('async', 'true');
        try {
            document.head.appendChild(scriptDom);
        } catch (e: any) {
            console.error(appendChildError(e, document.head.appendChild, scriptDom));
        }
        scriptDom.onload = () => {
            openWaterMarks(res);
        };
    });

